import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import ProjectCard from '../components/ProjectCard';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <>
      <Hero />
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-navy text-center mb-12 animate-fade-in">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <ServiceCard
              title="Bridge Painting"
              description="Durable, weather-resistant coatings for bridges, ensuring safety and longevity."
              image="/img/bridge-project.jpeg"
            />
            <ServiceCard
              title="Water Tower Painting"
              description="Specialized painting solutions for water towers, meeting industry standards."
              image="/img/water-tower-project.jpeg"
            />
            <ServiceCard
              title="Commercial Painting"
              description="Professional painting for commercial properties, enhancing aesthetics and durability."
              image="/img/commercial-project.jpeg"
            />
          </div>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-navy text-center mb-12 animate-fade-in">Our Projects</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <ProjectCard
              title="City Bridge Restoration"
              description="Restored a historic bridge with eco-friendly coatings, completed in 2024."
              image="/img/bridge-project.jpeg"
            />
            <ProjectCard
              title="Municipal Water Tower"
              description="Applied high-performance coatings to a 100ft water tower in 2023."
              image="/img/water-tower-project.jpeg"
            />
            <ProjectCard
              title="Office Complex Facade"
              description="Transformed a commercial building with modern finishes in 2025."
              image="/img/commercial-project.jpeg"
            />
          </div>
          <div className="text-center mt-8">
            <Link to="/projects" className="bg-navy text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-900 transition-colors">View All Projects</Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;